import React from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { graphql } from "@apollo/client/react/hoc"
import TabbedListingPage from "../Material/TabbedListingPage"
import { HasPermissionsQuery } from "../Functions/querys"
import PriceContainer from "./PricingContainer"
import PromoContainer from "./PromoContainer"

// Neither panel reads currentUser -- both only forward location/navigate down to
// their list header (for URL-driven filter state), and neither self-supplies
// those via a withApolloClient wrap the way most other panels do.
const pricingPromotionTabs = [
    { id: "#pricing", name: "Pricing", iconClassName: "fa fa-money", permissionRequired: "view_pricingtemplate", render: ({ location, navigate }) => <PriceContainer location={location} navigate={navigate} /> },
    { id: "#promotions", name: "Promotions", iconClassName: "fa fa-tags", permissionRequired: "view_promotiontemplate", render: ({ location, navigate }) => <PromoContainer location={location} navigate={navigate} /> },
]

const PricingPromotionsPage = (props) => {
    const location = useLocation()
    const navigate = useNavigate()

    return (
        <TabbedListingPage
            className="pricingPromotionsPage"
            tabs={pricingPromotionTabs.map(tab => ({ ...tab, render: () => tab.render({ location, navigate }) }))}
            hasPermissions={props.hasPermissions}
            loading={props.loading}
        />
    )
}

export { pricingPromotionTabs }

export default graphql(HasPermissionsQuery, {
    options: () => ({ variables: { userPermissions: ["view_pricingtemplate", "view_promotiontemplate"] } }),
    props: ({ data: { hasPermissions, loading } }) => ({ hasPermissions, loading }),
})(PricingPromotionsPage)
